export enum PopUpSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Full = 'full',
}
